import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components/macro';
import tw from 'tailwind.macro';
import messages from '../../containers/Search/View/messages';
import { colors } from '../../styles/constants';
import { buttonSubmitStyle } from '../ButtonSubmit';
import { h4Style } from '../H4';

const StepsContent = styled.div`
  ${tw`hidden mb-def
  md:block md:w-3`}
  height: 200px;
  position: sticky;
  top: 6rem;
`;

const CustomH4 = styled.p`
  ${h4Style};
  ${tw`font-medium mt-0 mb-def`};
  font-size: 1.2rem !important;
  font-weight: 500;
`;

const Anchor = styled.a`
  color: ${colors.primary400};
  text-decoration: none;
`;

const Button = styled.button`
  ${buttonSubmitStyle};
  ${({ customStyle }) => customStyle}
`;

const StickyNavButton = ({ action, customStyle }) => (
  <Button customStyle={customStyle} onClick={action}>
    <FormattedMessage {...messages.stickyNavButton} />
  </Button>
);

const StickyNav = ({ activeTab, CTA, navigation }) => (
  <StepsContent>
    {navigation.map((link) => (
      <CustomH4 key={link.id}>
        <Anchor activeStep={activeTab === link.id} href={`#${link.id}`}>
          {link.text}
        </Anchor>
      </CustomH4>
    ))}
    {CTA}
  </StepsContent>
);

StickyNavButton.propTypes = {
  action: PropTypes.func.isRequired,
  customStyle: PropTypes.arrayOf(PropTypes.string),
};

StickyNav.propTypes = {
  CTA: PropTypes.node,
  activeTab: PropTypes.string,
  navigation: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }),
  ),
};

export { StickyNav, StickyNavButton };
